module.exports = __webpack_public_path__ + "img/table_matriks.92bf2a55.png";